import { useRouter } from '@tanstack/react-router';
import { Button, Container, Group, Text, Title } from '@mantine/core';
import classes from './AclFallbackUi.module.css';

const AclFallbackUi = () => {
  const router = useRouter();

  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.label}>403</div>
        <Title className={classes.title}>Akses Ditolak</Title>
        <Text size="lg" ta="center" className={classes.description}>
          Anda tidak memiliki izin untuk mengakses fitur ini, silakan hubungi admin Anda
        </Text>
        <Group justify="center">
          <Button variant="white" size="md" onClick={() => router.history.back()}>
            Kembali
          </Button>
        </Group>
      </Container>
    </div>
  );
};

export default AclFallbackUi;
